export const MENU_BUTTON_FADE_TIME = 100
